var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.selectedColor.length > 0
    ? _c("div", { staticClass: "wf-current-refinements" }, [
        _c("div", { staticClass: "wf-current-refinements-title" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$resourceString["product.search.filters.results.for"]
              ) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wf-current-refinements-group" },
          _vm._l(_vm.selectedColor, function(item) {
            return _c(
              "a",
              { key: item, staticClass: "btn btn-white shadow-sm mx-1 my-1" },
              [
                _c("span", { staticClass: "mr-3" }, [
                  _vm._v("\n        " + _vm._s(item) + "\n      ")
                ]),
                _vm._v(" "),
                _c("span", {
                  staticClass: "png-icon png-icon-icons-glyph--k-close",
                  on: {
                    click: function($event) {
                      return _vm.removeColor(item)
                    }
                  }
                })
              ]
            )
          }),
          0
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }